import { useEffect, useState } from 'react'
import axios from 'axios'
import { buildRequestPrerequisites } from '../services/dataService'
import { StringUtils, BrowserUtils } from '../utils/siteUtils'
import { writeStoreToBrowserStorage, BROWSER_STORAGE_TTL } from '../utils/storeUtils'

const verifyZipCode = async ({ globalState, zip }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })
  const url = `${baseUrl}/postal-code/${zip}`
  try {
    const { data, status } = await axios({
      method: 'get',
      url,
      headers,
      params: {
        api_key: apiKey
      }
    })
    return {
      data: data.data,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error }
  }
}

export default (landingContext, location, updateGlobalState, globalState) => {
  const { experienceState } = landingContext
  const { isCobrandDR, isAssigned } = experienceState
  const queryZipcode = location && location.initQueryParams && location.initQueryParams.zipcode
  const queryZip = location && location.initQueryParams && StringUtils.isZipValid(location.initQueryParams.zip) ? location.initQueryParams.zip : false
  const queryZipUsable = (isCobrandDR && isAssigned && queryZipcode) || queryZip
  const [cookieZip, setCookieZip] = useState(experienceState && experienceState.cookieZip)
  const globalZip = globalState.zip
  const [zip, setZip] = useState(globalZip || queryZipUsable || cookieZip)
  const zipInfo = landingContext && landingContext.zipInfo
  const globalZipError = globalState.zipError
  const [zipError, setZipError] = useState(zipInfo && zipInfo.zipError)
  const [serviceableZipError, setServiceableZipError] = useState(zipInfo && zipInfo.serviceableZipError)
  const numRegex = /^\d{5}$/

  const getZipData = async zip => {
    if (zip && !zip.toString().match(numRegex)) setZipError(true)
    if (zip && !!zip.toString().match(numRegex)) {
      const { data, error, status } = await verifyZipCode({ globalState, zip })
      if (!error && status === 200) {
        setZipError(!data.isKnownZipCode)
        setServiceableZipError(!data.isWithinServiceableArea)

        if (BrowserUtils.isBrowser) {
          writeStoreToBrowserStorage({ ManualZipCode: true }, 'ManualZipCode', BROWSER_STORAGE_TTL.TTL3Day)
          writeStoreToBrowserStorage({ ZipCode: zip }, 'ZipCode', BROWSER_STORAGE_TTL.TTL3Day)
        }
      }
    }
  }

  useEffect(() => {
    if (!!globalZipError !== !!zipError) updateGlobalState({ zipError })
  }, [updateGlobalState, zipError, globalZipError])

  useEffect(() => {
    if ((!globalZip && queryZipUsable) || (cookieZip && queryZipUsable && cookieZip !== queryZipUsable)) {
      setZip(queryZipUsable)
      setCookieZip(queryZipUsable)
      updateGlobalState({ zip: queryZipUsable })
    }
    if (globalZip && globalZip !== zip) setZip(globalZip)
  }, [queryZipUsable, globalZip, zip, updateGlobalState])

  useEffect(() => {
    if (!globalState?.useDealerZip && !globalZip && !queryZipUsable && cookieZip) updateGlobalState({ zip: cookieZip })
  }, [])

  landingContext.zipInfo = { zip, zipError, serviceableZipError }
  landingContext.validateZip = async zip => {
    const zipStr = zip ? zip.toString() : ''
    const isValidFormat = zipStr.length === 5 && zipStr.match(numRegex)
    const hasFormatError = zipStr.length === 0 || zipStr.length < 5

    experienceState.customerInfo.zip = zip

    // Handle format errors (empty or incomplete)
    if (hasFormatError) {
      setZipError(true)
      updateGlobalState({ zip, updatedZip: true, zipError: true })
      return
    }

    // Handle valid 5-digit format - verify with API
    if (isValidFormat) {
      const { data, error, status } = await verifyZipCode({ globalState, zip })
      if (!error && status === 200) {
        const isInvalidZip = !data.isKnownZipCode
        setZipError(isInvalidZip)
        setServiceableZipError(!data.isWithinServiceableArea)
        updateGlobalState({ zip, updatedZip: true, zipError: isInvalidZip })
      }
      return
    }
  }
}
